import script from "./Nyhongshu.vue?vue&type=script&setup=true&lang=js"
export * from "./Nyhongshu.vue?vue&type=script&setup=true&lang=js"

import "./Nyhongshu.vue?vue&type=style&index=0&id=54354b8c&lang=less&scoped=true"
script.__scopeId = "data-v-54354b8c"

export default script